import React from "react";
import { Body, Subheading } from "../../atoms";
export var OfficeInfoBlock = function(param) {
    var country = param.country, children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(Subheading, {
        className: "mb-7"
    }, country), /*#__PURE__*/ React.createElement(Body, {
        className: "prose md:prose-md"
    }, children));
};

//# sourceMappingURL=OfficeInfoBlock.js.map